import { BCMSDate, DisabledPrompt, useBCMSContext, BCMSStateManagerCRUD, useStateManager, BCMSRecord, StateManager } from "bcms-react";
import Classes from "model";
import React from 'react';
import { SVGAsset } from 'res';
import { TableBody, TableColumnContainer, TableColumnView, TableView, WidgetContainer, WidgetView } from 'components/shared';
import NoWireTransferTableRow from '../NoWireTransferTableRow';

/**
 * @function ScheduledWiresWidget
 * @return {React.Component}
 * @exported true
 * @description The widget that shows the Scheduled wires
 */

export default function ScheduledWiresWidget(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,
  });

  return(
    <StateManager state={ { data, ui } } controller={ controller }>
      <WidgetContent/>
    </StateManager>
  )
}

export const getDefaultData = () => ({
  // no used data for now
});

export const getDefaultUI = () => ({
  // no ui changes for now
});

function WidgetContent(props) {
  const { data } = useStateManager();
  
  return (
    <WidgetContainer className="scheduled-wire-widget">
      <WidgetView text="Scheduled Wires">
        <TableView>
          <TableColumnContainer>
            <TableColumnView className="text-left ref-number-text" text="Ref #" />
            <TableColumnView className="text-left payee-text" text="Payee" />
            <TableColumnView className="text-left notify-payee-text" text="Notify Payee" />
            <TableColumnView className="text-left schedule-text" text="Schedule" />
            <TableColumnView className="text-left amount-text" text="Amount" />
            <TableColumnView className="text-left next-wire-date-text" text=
              {<>Next Wire Date
                <DisabledPrompt>
                  <SVGAsset id="ArrowUpIcon" className="clickable" />
                </DisabledPrompt>
              </>} 
            />
          </TableColumnContainer>
          <TableBody>
            <NoWireTransferTableRow colspan="6" />
          </TableBody>
        </TableView>
      </WidgetView>
    </WidgetContainer>
  );
}